import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as Objects from '@core/objects';
import { AddRequest } from '@app/models/add-project';
import { UrlService } from '@core/services/url/url.service';
import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service';
@Injectable({
    providedIn: 'root'
})
export class AddProjectRequests {
    constructor(
        private http: HttpClient,
        private url: UrlService,
        private responseUtilsSrv: CoreResponseUtilsService // Inject the simulator
    ) {}

    submitAddProject$(data: AddRequest, prefixUrl: string = ""): Observable<any> {
        const postData = {
            info: data.info,
            due_date: data.due_date,
            files: data.files.map((f: Objects.FileMetadata) => f.uuid),
            labels: data.labels.map((l: Objects.Label) => l.id),
            version: data.version,
            workflow: data.workflow
        };
        return this.http.post(this.url.build(prefixUrl + "/projects"), postData);
    }
}